<template>
  <span>
    <input v-model="item.price" class="input-option h-38" :ref="'price' + id"  @keyup="verityPrice()" maxlength="5">
    <!--
    <div v-if="show.check" class="del-c-block change-price-block">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header text-left">
              <h4 class="modal-title text-red">提醒</h4>
            </div>
            <div class="modal-body text-left text-red">
              <p>確定修改金額？</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" @click="cancelChange">還原</button>
              <button type="button" class="btn btn-success" @click="changePrice">確定</button>
            </div>
          </div>
        </div>
      </div>
      -->
  </span>
</template>
<script>
import $ from 'jquery'
export default{
  props: {
    item: {
      type: [Object, String]
    },
    id: {
      type: Number
    }
  },
  data () {
    return {
      priceArray: [],
      show: {
        check: false
      }
    }
  },
  methods: {
    verityPrice () {
      var e = $(this.$refs['price' + this.id])
      if (isNaN(e.val())) {
        e.val(e.val().match(/[-]?[0-9]*/))
      }
      this.item.price = e.val()
    }
  }
}
</script>
<style lang="sass">
.change-price-block
  top: 25px !important
  position: absolute
  z-index: 400
  right: -70px
.disabled input
  pointer-events: none
  color: rgb(238, 238, 238)
  cursor: not-allowed
  background: #eee
</style>



// WEBPACK FOOTER //
// PriceInput.vue?01fbec93